module.exports = __webpack_public_path__ + "img/grey_circle.742c91b5.svg";